import { message } from "antd";
import React from "react";
import func from "@uikit/func";
import { uploadTypes } from "../uiview/views/Nodes/constants";

export default function useHandleOtherTypeRun({
  getHomeNodes,
  getSourceOfTruthResults,
  setEdgeLineParam,
  setQueryLoading,
  setNodes,
}) {
  // 处理上传file类型
  const handleUploadFileRun = async (text, sourceNodeId, targetNodeId, edgeId, disabled) => {
    const nodes = getHomeNodes();
    const sourceNode = nodes.find(x => x.id === sourceNodeId);

    if (uploadTypes.includes(sourceNode.data.displayType) === false) return false;

    setEdgeLineParam({
      id: edgeId,
      loading: disabled ? false : true,
      enterText: text,
    });
    try {
      setQueryLoading(edgeId, "isGetQuery", true);
      if (disabled) {
        return true;
      }
      const res = await getSourceOfTruthResults(text, {
        file: sourceNode.data.textAreaValue.s3Path,
        loader: "PDFReader",
      });
      setNodes(prevList => {
        return prevList.map(x => {
          if (x.id === targetNodeId) {
            return {
              ...x,
              data: {
                ...x.data,
                displayType: "text",
                textAreaValue: res?.data?.data?.response,
              },
            };
          }
          return x;
        });
      });
    } catch (error) {
      func.messageError(error);
    } finally {
      setEdgeLineParam({
        id: edgeId,
        loading: false,
      });
    }
    return true;
  };

  return {
    handleUploadFileRun,
  };
}
